// Hand-crafted, illustrative SVG visuals for featured case studies.
// Not screenshots — stylized product diagrams that convey each system at a glance.

const panelClass =
  "relative w-full overflow-hidden rounded-2xl border border-[var(--border-subtle)] bg-[var(--bg-base)]";

const GoalTrackrDiagram = () => {
  const columns = [
    { title: "BACKLOG", cards: [40, 28], tone: "#3f3f46" },
    { title: "IN PROGRESS", cards: [52, 34, 24], tone: "#10b981" },
    { title: "DONE", cards: [36], tone: "#6b7280" },
  ];
  return (
    <div className={panelClass} data-testid="diagram-goaltrackr">
      <svg viewBox="0 0 420 220" className="w-full h-auto" role="img" aria-label="GoalTrackr kanban board">
        <rect width="420" height="220" fill="transparent" />
        {/* toolbar */}
        <rect x="20" y="18" width="110" height="14" rx="7" fill="rgba(255,255,255,0.08)" />
        <rect x="330" y="16" width="70" height="18" rx="9" fill="rgba(16,185,129,0.14)" stroke="rgba(16,185,129,0.4)" />
        <text x="365" y="29" textAnchor="middle" fontFamily="monospace" fontSize="9" fill="#10b981">SPRINT 4</text>
        {columns.map((col, ci) => {
          const x = 20 + ci * 130;
          let y = 56;
          return (
            <g key={col.title}>
              <text x={x + 6} y={50} fontFamily="monospace" fontSize="9" letterSpacing="1.5" fill="#666">
                {col.title}
              </text>
              <rect x={x} y={56} width="118" height="146" rx="10" fill="rgba(255,255,255,0.02)" stroke="rgba(255,255,255,0.06)" />
              {col.cards.map((w, idx) => {
                const cardY = y;
                y += 44;
                return (
                  <g key={idx}>
                    <rect x={x + 8} y={cardY} width="102" height="34" rx="7" fill="rgba(255,255,255,0.04)" stroke="rgba(255,255,255,0.08)" />
                    <rect x={x + 16} y={cardY + 9} width={w} height="6" rx="3" fill="rgba(255,255,255,0.28)" />
                    <circle cx={x + 20} cy={cardY + 24} r="3" fill={col.tone} />
                    <rect x={x + 28} y={cardY + 21} width="26" height="5" rx="2.5" fill="rgba(255,255,255,0.12)" />
                    <circle cx={x + 100} cy={cardY + 24} r="6" fill="rgba(255,255,255,0.08)" />
                  </g>
                );
              })}
            </g>
          );
        })}
      </svg>
    </div>
  );
};

const CineReserveDiagram = () => {
  const rows = 4;
  const cols = 9;
  // status: 0 available, 1 booked, 2 selected
  const layout = [
    [1, 1, 0, 0, 0, 0, 0, 1, 1],
    [1, 0, 0, 2, 2, 0, 0, 0, 1],
    [0, 0, 2, 2, 2, 2, 0, 0, 0],
    [1, 1, 0, 0, 1, 1, 0, 1, 1],
  ];
  const color = (s) =>
    s === 1
      ? "rgba(255,255,255,0.06)"
      : s === 2
      ? "#10b981"
      : "rgba(255,255,255,0.16)";
  return (
    <div className={panelClass} data-testid="diagram-cinereserve">
      <svg viewBox="0 0 420 220" className="w-full h-auto" role="img" aria-label="CineReserve seat map">
        {/* screen */}
        <path d="M110 34 Q210 16 310 34" fill="none" stroke="rgba(255,255,255,0.35)" strokeWidth="2.5" strokeLinecap="round" />
        <text x="210" y="52" textAnchor="middle" fontFamily="monospace" fontSize="9" letterSpacing="2" fill="#666">SCREEN</text>
        {/* live badge */}
        <rect x="20" y="18" width="86" height="18" rx="9" fill="rgba(16,185,129,0.14)" stroke="rgba(16,185,129,0.4)" />
        <circle cx="33" cy="27" r="3.5" fill="#10b981" />
        <text x="44" y="30" fontFamily="monospace" fontSize="8.5" fill="#10b981">LIVE SEATS</text>
        {/* seats */}
        {layout.map((row, r) =>
          row.map((s, c) => {
            const x = 90 + c * 27;
            const y = 74 + r * 24;
            return (
              <rect
                key={`${r}-${c}`}
                x={x}
                y={y}
                width="20"
                height="16"
                rx="4"
                fill={color(s)}
                stroke={s === 2 ? "rgba(16,185,129,0.5)" : "rgba(255,255,255,0.06)"}
              />
            );
          })
        )}
        {/* legend */}
        <g transform="translate(90,190)">
          <rect x="0" y="0" width="12" height="10" rx="3" fill="rgba(255,255,255,0.16)" />
          <text x="18" y="9" fontFamily="monospace" fontSize="8" fill="#666">Available</text>
          <rect x="86" y="0" width="12" height="10" rx="3" fill="#10b981" />
          <text x="104" y="9" fontFamily="monospace" fontSize="8" fill="#666">Selected</text>
          <rect x="170" y="0" width="12" height="10" rx="3" fill="rgba(255,255,255,0.06)" />
          <text x="188" y="9" fontFamily="monospace" fontSize="8" fill="#666">Booked</text>
        </g>
      </svg>
    </div>
  );
};

const diagrams = {
  GoalTrackr: GoalTrackrDiagram,
  CineReserve: CineReserveDiagram,
};

export const ProjectDiagram = ({ name }) => {
  const Cmp = diagrams[name];
  if (!Cmp) return null;
  return <Cmp />;
};
